import React, { Component } from 'react';
import ApproveButton from '../../approve/button';
import RejectComponents from '../../reject/component';
import RejectButton from '../../reject/button';
import RoleView from '../../../RoleView';
import RequestDetailModal from '../../../travel-expense/detail/index';
import PDFDownload from '../../../travel-expense/pdf/index';
import InputModal from '../../../common/modal/input/index';
import ConfirmModal from '../../../common/modal/confirm/index';

class PendingActionView extends Component {
  constructor(props) {
    super(props);
    this.approveButtonAction = this.approveButtonAction.bind(this);
    this.rejectedButtonAction = this.rejectedButtonAction.bind(this);
  }


  async approveButtonAction() {
    const { request, actionButtonEvents } = this.props;

    await actionButtonEvents.approveRequest(request._id);
  }

  async rejectedButtonAction() {
    const { request, actionButtonEvents } = this.props;

    await actionButtonEvents.rejectedRequest(request._id);
  }

  render() {
    const {
      roles, request, actionButtonEvents, waitingForCancelled
    } = this.props;

    return (
      <RoleView key="manager-actions" roles={roles}>
        <div>
          <RequestDetailModal
            request={request}
            isManager
            approve={this.approveButtonAction}
            reject={actionButtonEvents.rejectedRequest}
            waitingForCancelled={waitingForCancelled}
          />
          <span>
                    &nbsp;
          </span>
          <ConfirmModal
            title="Emin misiniz?"
            trigger={ApproveButton}
            triggerInfo={waitingForCancelled}
            confirm={this.approveButtonAction}
          >
            <h3>
              Talep Onaylanacak
            </h3>
          </ConfirmModal>
          <span>
                    &nbsp;
          </span>
          <InputModal
            title="Harcırah reddedilecek"
            trigger={RejectButton}
            triggerInfo={waitingForCancelled}
            submit={actionButtonEvents.rejectedRequest}
            submitLabel="Onayla"
            Component={RejectComponents}
            ComponentProps={{ harcirahId: request._id }}
          />
          <span>
                    &nbsp;
          </span>
          <PDFDownload
            request={request}
          />
          <span>
            &nbsp;
          </span>
        </div>
      </RoleView>
    );
  }
}

export default PendingActionView;



// WEBPACK FOOTER //
// ./src/components/actions/view/pending/index.js